const DigitalMarketingAgencyDesignDetails = () => {
  return (
    <>
      <div className="ca-design-section section-space--sm-top section-space-bottom">
        <div className="container">
          <div className="row g-4 gy-5">
            <div className="col-xl-11 col-xxl-10">
              <h3 className="ca-design-section__heading heading-3 clr-white font-weight-semibold margin-bottom-10">
                "If You think{" "}
                <span className="clr-red">Good Design is Expensive</span>, you
                should look at the costs of bad design"
              </h3>
              <p className="heading-font clr-paragraph-light fs-18 max-60ch">
                Level up your recovery with email campaigns proven highly
                effective for leading eCommerce brands, and backed by years.
              </p>
            </div>
            <div className="col-lg-6">
              <div className="d-flex flex-column justify-content-between h-100">
                <div className="margin-bottom-15">
                  <ul className="list list-row flex-wrap gap-10 margin-bottom-12">
                    <li>
                      <h3 className="heading-3 clr-white margin-bottom-2 font-weight-semibold">
                        300+
                      </h3>
                      <p className="mb-0 clr-paragraph-light">
                        Products Completed
                      </p>
                    </li>
                    <li>
                      <h3 className="heading-3 clr-white margin-bottom-2 font-weight-semibold">
                        $1.69M
                      </h3>
                      <p className="mb-0 clr-paragraph-light">
                        Earned to worldwide
                      </p>
                    </li>
                    <li>
                      <h3 className="heading-3 clr-white margin-bottom-2 font-weight-semibold">
                        300+
                      </h3>
                      <p className="mb-0 clr-paragraph-light">
                        Professional Members
                      </p>
                    </li>
                  </ul>
                  <a
                    href="#"
                    className="btn btn-primary bgc-primary-gradient :bgc-primary-gradient border-0"
                  >
                    Get Started
                  </a>
                </div>
                <div className="mt-auto">
                  <h5 className="heading-5 d-inline-block ca-subheading-gradient margin-bottom-6 ca-design-section__title-top">
                    Loved by
                  </h5>
                  <h2 className="heading-1 margin-bottom-12 ca-design-section__title">
                    850,00+
                  </h2>
                  <div className="row g-4">
                    <div className="col-6">
                      <img
                        src="assets/img/creative-agency/brand-1.png"
                        alt="image"
                        className="img-fluid"
                      />
                    </div>
                    <div className="col-6">
                      <img
                        src="assets/img/creative-agency/brand-2.png"
                        alt="image"
                        className="img-fluid"
                      />
                    </div>
                    <div className="col-6">
                      <img
                        src="assets/img/creative-agency/brand-3.png"
                        alt="image"
                        className="img-fluid"
                      />
                    </div>
                    <div className="col-6">
                      <img
                        src="assets/img/creative-agency/brand-4.png"
                        alt="image"
                        className="img-fluid"
                      />
                    </div>
                    <div className="col-6">
                      <img
                        src="assets/img/creative-agency/brand-5.png"
                        alt="image"
                        className="img-fluid"
                      />
                    </div>
                    <div className="col-6">
                      <img
                        src="assets/img/creative-agency/brand-6.png"
                        alt="image"
                        className="img-fluid"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="border border-red-clr rounded-4 padding-5 h-100">
                <div className="rounded-4 overflow-hidden h-100">
                  <img
                    src="assets/img/creative-agency/design-section-img.png"
                    alt="image"
                    className="img-fluid w-100 h-100 object-fit-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DigitalMarketingAgencyDesignDetails;
